














































































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import entries from 'lodash/entries'

import { User, ActionUpdate } from '../store/user/types'
import Default from '../components/common/Default.vue'
import '../router'
import { Page } from '../type'
import FeatureType from '../lib/masters/FeatureType'
import Feature from '../lib/masters/Feature'
import NotificationAlert from '../components/common/NotificationAlert.vue'
import SpecialtyType from '../lib/masters/SpecialtyType'
import Specialty from '../lib/masters/Specialty'
import { PROFILE_TEMPLATE } from '../lib/appHelper'

const UserModule = namespace('user')
type Croppa = {
  generateBlob: (callback: (blob: Blob) => void, type: string) => void
  hasImage: () => boolean
}

@Component({ components: { Default, NotificationAlert } })
export default class Mypage extends Vue {
  @UserModule.Getter('user') user!: User
  @UserModule.Action('update') update!: ActionUpdate
  MAX_PROFILE_LENGTH = 2000

  // app state
  isMounted = false
  updated = false
  updating = false
  error = false
  croppa: Croppa | null = null
  croppa2: Croppa | null = null
  valid = true

  // form state
  familyName = ''
  firstName = ''
  imageUrl: string | null = null
  imageUrl2: string | null = null
  profile = PROFILE_TEMPLATE
  specialtyType: SpecialtyType = SpecialtyType.Insurance
  featureTypes: FeatureType[] = []

  // form rule
  nameRules = [(v: string) => !!v || '入力してください']
  profileRules = [
    (v: string) =>
      !v ||
      v.length <= this.MAX_PROFILE_LENGTH ||
      `${this.MAX_PROFILE_LENGTH}文字以内で入力してください`
  ]
  featuresRules = [
    (v: string) => v.length <= 3 || '選択できる特徴は3つまでです'
  ]

  mounted() {
    if (!this.user) {
      this.$router.push({ name: Page.Home })
      return
    }
    const {
      familyName,
      firstName,
      imageUrl,
      imageUrl2,
      profile,
      specialtyType,
      featureTypes
    } = this.user
    if (familyName) this.familyName = familyName
    if (firstName) this.firstName = firstName
    if (imageUrl) this.imageUrl = imageUrl
    if (imageUrl2) this.imageUrl2 = imageUrl2
    if (specialtyType) this.specialtyType = specialtyType
    if (featureTypes) this.featureTypes = featureTypes
    if (profile) this.profile = profile
    this.isMounted = true
  }

  get features() {
    return entries(Feature).map(([key, obj]) => ({
      text: obj.text,
      value: key
    }))
  }

  get specialties() {
    return entries(Specialty).map(([key, obj]) => ({
      text: obj.text,
      value: key
    }))
  }

  async handleSubmit() {
    if (!(this.$refs.userForm as HTMLFormElement).validate()) return
    this.updating = true
    const { familyName, firstName, specialtyType, featureTypes, profile } = this
    const [image, image2] = await Promise.all([
      this.getImageBlob(this.croppa),
      this.getImageBlob(this.croppa2)
    ])
    await this.update({
      user: {
        ...this.user,
        familyName,
        firstName,
        specialtyType,
        featureTypes,
        profile
      },
      image,
      image2
    })
      .then(() => {
        this.updated = true
      })
      .catch(() => {
        this.error = true
      })
    this.updating = false
  }

  async getImageBlob(croppa: Croppa | null): Promise<Blob | null | undefined> {
    if (!croppa) return
    if (!croppa.hasImage()) return null
    return new Promise(resolve =>
      croppa.generateBlob((blob: Blob) => {
        resolve(blob)
      }, 'image/png')
    )
  }

  removeFeature(value: FeatureType) {
    this.featureTypes = this.featureTypes.filter(type => type !== value)
  }
}
